import React, { useCallback } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Card } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { ElementPreview } from 'modules/forms/components/preview/ElementPreview'
import { Element } from 'modules/forms/lib/Element'
import { Form } from 'modules/forms/lib/Form'
import { SectionElement } from 'modules/forms/lib/elements/SectionElement'
import { Answer } from 'modules/forms/lib/types'

interface FormRenderProps {
  form: Form
  onFormUpdated?: () => void
}

const FormAnswerInline: React.FC<FormRenderProps> = ({ form, onFormUpdated }) => {
  const handleAnswer = useCallback(
    (answer: Answer, elementId: string) => {
      const element = form?.getElement(elementId)
      if (element) element.answer = answer
      onFormUpdated?.()
    },
    [form, onFormUpdated]
  )

  return (
    <Box gap="s24">
      {form.elements.map((element: Element, index: number) => (
        <Box key={element.uuid} gap="s12">
          <Text size="200" whiteSpace="nowrap" weight="medium" color="textPrimary">{`${i18n.t(
            'forms.question'
          )} ${index + 1}`}</Text>
          <F0Card>
            <Box style={{ pointerEvents: 'auto' }}>
              <ElementPreview
                element={element}
                mode="answer"
                handleAnswer={handleAnswer}
                titleSize="small"
              />
            </Box>
          </F0Card>

          {element instanceof SectionElement && (
            <>
              {element.elements.map((child: Element) => (
                <F0Card key={child.uuid}>
                  <Box style={{ pointerEvents: 'auto' }}>
                    <ElementPreview element={child} mode="answer" handleAnswer={handleAnswer} />
                  </Box>
                </F0Card>
              ))}
              <Box flexDirection="row" alignItems="center">
                <Box width="full" />
                <Text.Normal whiteSpace="nowrap" className="text-base p-3">
                  {i18n.t('forms.section_end')}
                </Text.Normal>
                <Box width="full" />
              </Box>
            </>
          )}
        </Box>
      ))}
    </Box>
  )
}

/**
 * @public
 *
 * TODO: Remove once FormAnswerInline is used anywhere
 * */
export default FormAnswerInline
